(() => {
  document.querySelectorAll('.hero-carousel').forEach((root) => {
    const slides = root.querySelectorAll('.hero-carousel__slide');
    const dots   = root.querySelectorAll('.hero-carousel__dot');
    const prev   = root.querySelector('.hero-carousel__nav--prev');
    const next   = root.querySelector('.hero-carousel__nav--next');
    if (!slides.length) return;

    const interval = parseInt(root.dataset.autoplay, 10) || 6000;
    root.style.setProperty('--autoplay', interval + 'ms');

    let index = 0;
    let timer = null;

    const go = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === index));
      dots.forEach((d, k) => {
        d.classList.remove('is-active');
        void d.offsetWidth; // restart CSS animation
        if (k === index) d.classList.add('is-active');
      });
      restart();
    };

    const restart = () => {
      clearTimeout(timer);
      if (root.classList.contains('is-paused')) return;
      timer = setTimeout(() => go(index + 1), interval);
    };

    prev?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));
    dots.forEach((d) => d.addEventListener('click', () => go(parseInt(d.dataset.index, 10))));

    root.addEventListener('mouseenter', () => { root.classList.add('is-paused'); clearTimeout(timer); });
    root.addEventListener('mouseleave', () => { root.classList.remove('is-paused'); restart(); });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  go(index - 1);
      if (e.key === 'ArrowRight') go(index + 1);
    });

    let startX = 0;
    root.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend',   (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) go(index + (dx < 0 ? 1 : -1));
    });

    restart();
  });
})();